// extracted by mini-css-extract-plugin
export default {"parent":"paymentPriceItem_parent__u6SBC","parentContent":"paymentPriceItem_parentContent__4bUQW","parentPrice":"paymentPriceItem_parentPrice__PItj9"};